import React, { useCallback, useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import imageHeaderBanner from "./../../assets/images/global/imageHeaderBannerReservation.png";
import DescriptionSplit from "../../components/Description/description-split";
import Select from "../../components/Inputs/select";
import Hr from "../../components/Style/hr";
import H2 from "../../components/Titles/h2";
import H3 from "../../components/Titles/h3";
import H4 from "../../components/Titles/h4";
import H5 from "../../components/Titles/h5";
import H6 from "../../components/Titles/h6";
import Button from "../../components/Buttons/button";
import Api from "../../services/api.service";
import AccommodationDisplayed from "./components/accommodation-displayed";
import ListOfServices from "./components/list-of-services";
import PersonnalInfoForm from "../../components/Forms/personnal-info-form";
import BackgroundImage from "../../components/Banner/background-header";
import { faUser } from "@fortawesome/free-solid-svg-icons";
import moment from "moment";
import { Helmet } from "react-helmet";
import lodash from "lodash";
import Validator from "../../services/validator.service";
import Helper from "../../services/helper.service";
import DateFieldInput from "../../components/Inputs/date-field";
import * as _ from "lodash";
import Icon from "../../components/Images/icon";
import iconCalendar from "../../assets/icons/reservation/calendar.svg";
import iconUsers from "../../assets/icons/reservation/users.svg";
import iconAccommodation from "../../assets/icons/reservation/accommodation.svg";
import iconServices from "../../assets/icons/reservation/services.svg";
import SerenityPackCard from "../../components/Card/serenity-pack-card";

const normalizeBlockedAccommodation = (value) => {
    const accommodation = String(value || 'domain')
        .trim()
        .toLowerCase();

    if (accommodation === 'house') {
        return 'home';
    }

    if (
        accommodation === 'home' ||
        accommodation === 'annex' ||
        accommodation === 'domain'
    ) {
        return accommodation;
    }

    return 'domain';
};

const normalizeBlockedDate = (blockedDate) => {
    const start =
        blockedDate.startDate ??
        blockedDate.start;

    const end =
        blockedDate.endDate ??
        blockedDate.end;

    return {
        ...blockedDate,

        startDate:
            moment(start).format('YYYY-MM-DD'),

        endDate:
            moment(end).format('YYYY-MM-DD'),

        typeOfAccommodation:
            normalizeBlockedAccommodation(
                blockedDate.typeOfAccommodation
            )
    };
};

export default function Reservation() {
    const { t, i18n } = useTranslation();
    const navigate = useNavigate();
    var touristTax = 3.3;

    const fixedColumnRef = useRef(null);
    const [divHeight, setDivHeight] = useState(0);
    const [screenHeight, setScreenHeight] = useState(window.innerHeight);

    const calculateDivHeight = () => {
        if (fixedColumnRef.current) {
            return fixedColumnRef.current.getBoundingClientRect().height;
        }
        return 0;
    };


    // Update the height once the component mounts
    useEffect(() => {
        // Calculate and set the div height on mount
        const height = calculateDivHeight();
        setDivHeight(height);

        // Function to update the screen height state
        const updateScreenHeight = () => {
            setScreenHeight(window.innerHeight);
        };

        // Update screen height on mount
        updateScreenHeight();

        // Add event listener for window resize to update screen height
        window.addEventListener('resize', updateScreenHeight);

        // Cleanup event listener on unmount
        return () => {
            window.removeEventListener('resize', updateScreenHeight);
        };
    }, []);

    const getInitialState = () => {
        const stayDatas = Api.getStayDatas();
        const storedStayDates = localStorage.getItem('stayDates');
        const storedNbAdults = localStorage.getItem('nbAdults');
        const storedNbChilds = localStorage.getItem('nbChilds');
        const storedAccommodationSelected = localStorage.getItem('accommodationSelected');
        const storedServicesSelected = localStorage.getItem('servicesSelected');
        const storedPersonnalInfoFormData = localStorage.getItem('personnalInfoFormData');

        /*** CHECK DATES  ***/
        const tomorrow = new Date();
        tomorrow.setHours(0, 0, 0, 0);
        tomorrow.setDate(tomorrow.getDate() + 1);

        const defaultStayDates = {
            // startDate: moment(new Date()).add(1, 'days').format('YYYY-MM-DD'),
            // endDate: moment(new Date()).add(3, 'days').format('YYYY-MM-DD')
            startDate: null,
            endDate: null
        };

        let stayDates = storedStayDates ? JSON.parse(storedStayDates) : stayDatas.stayDates || defaultStayDates;

        if (new Date(stayDates.startDate) < tomorrow || new Date(stayDates.endDate) < tomorrow) {
            stayDates = defaultStayDates;
        }

        const nbPersons = _.get(stayDatas, "nbAdults", 0) + _.get(stayDatas, "nbChilds", 0);

        let tmpAccommodationSelected = "";

        if (storedAccommodationSelected && !_.isArray(JSON.parse(storedAccommodationSelected))) {
            tmpAccommodationSelected = JSON.parse(storedAccommodationSelected) || "";
        }

        return {
            stayDates: stayDates,
            nbAdults: Number(storedNbAdults) || nbPersons || "",
            nbChilds: Number(storedNbChilds) || "",
            accommodationSelected: tmpAccommodationSelected,
            servicesSelected: storedServicesSelected ? JSON.parse(storedServicesSelected) : [],
            personnalInfoFormData: storedPersonnalInfoFormData ? JSON.parse(storedPersonnalInfoFormData) : {
                lastname: "",
                firstname: "",
                email: "",
                phone: ""
            }
        };
    };

    const [stayDates, setStayDates] = useState(getInitialState().stayDates);
    const [nbAdults, setNbAdults] = useState(getInitialState().nbAdults);
    const [nbChilds, setNbChilds] = useState(getInitialState().nbChilds);
    const [displayedAccommodation] = useState(['domain', 'home', 'annex']);
    const [accommodationPrice, setAccommodationPrice] = useState(0);
    const [discountLongAccommodation, setDiscountLongAccommodation] = useState(0);
    const [accommodationSelected, setAccommodationSelected] = useState(getInitialState().accommodationSelected);
    const [servicesSelected, setServicesSelected] = useState(getInitialState().servicesSelected);
    const [personnalInfoFormData, setPersonnalInfoFormData] = useState(getInitialState().personnalInfoFormData);
    const [blockedDates, setBlockedDates] = useState([]);
    const [minimumStayRules, setMinimumStayRules] = useState([]);
    const [prices, setPrices] = useState({
        annex: { price: 0, listOfDiscountForLongReservation: [], cleaning: 0 },
        home: { price: 0, listOfDiscountForLongReservation: [], cleaning: 0 },
        domain: { price: 0, listOfDiscountForLongReservation: [], cleaning: 0 }
    });
    const [services, setServices] = useState([]);
    const [displayFormContactDetails, setDisplayFormContactDetails] = useState(false);
    const [errorsPersonnalInfo, setErrorsPersonnalInfo] = useState({});

    const [cheaperDates, setCheaperDates] = useState([]);
    const [promoDates, setPromoDates] = useState([]);
    const [isSendingQuotation, setIsSendingQuotation] = useState(false);

    const maxPeopleDomain = 22;
    const maxPeopleHome = 12;
    const maxPeopleAnnex = 10;
    const ranInitialCheapRef = useRef(false);
    const lastPriceReqRef = useRef(null);

    const updatePersonnalInfoFormData = (newData) => { setPersonnalInfoFormData(newData) };

    const getNbDaysStay = useCallback(() => {
        const days = moment(stayDates.endDate).diff(stayDates.startDate, 'days');
        return lodash.isNaN(days) ? 0 : days;
    }, [stayDates]);

    const getMinimumStayForStartDate = useCallback(
        (
            startDate,
            accommodation = accommodationSelected
        ) => {
            const start = moment(startDate).startOf('day');

            if (!start.isValid()) {
                return {
                    minNights: 1,
                    label: null,
                    matchingRule: null
                };
            }

            let minNights = 1;
            let matchingRule = null;

            if ([5, 6].includes(start.day())) {
                minNights = 2;

                matchingRule = {
                    id: 'default-weekend',
                    label: t('reservation.weekend', {
                        defaultValue: 'Week-end'
                    }),
                    minNights: 2
                };
            }

            const arrivalDate =
                start.format('YYYY-MM-DD');

            for (const rule of minimumStayRules || []) {
                if (!rule || rule.active === false) {
                    continue;
                }

                const accommodations =
                    Array.isArray(rule.accommodations)
                        ? rule.accommodations
                        : [];

                if (
                    accommodation &&
                    accommodations.length &&
                    !accommodations.includes(accommodation)
                ) {
                    continue;
                }

                if (
                    arrivalDate < String(rule.startDate) ||
                    arrivalDate > String(rule.endDate)
                ) {
                    continue;
                }

                const ruleMinNights =
                    Number(rule.minNights || 1);

                if (ruleMinNights > minNights) {
                    minNights = ruleMinNights;
                    matchingRule = rule;
                }
            }

            return {
                minNights,
                label: matchingRule?.label || null,
                matchingRule
            };
        },
        [
            accommodationSelected,
            minimumStayRules,
            t
        ]
    );

    const getMinimumStayValidation = useCallback(
        (
            dates,
            accommodation = accommodationSelected
        ) => {
            const start = moment(
                dates?.startDate
            ).startOf('day');

            const end = moment(
                dates?.endDate
            ).startOf('day');

            if (
                !start.isValid() ||
                !end.isValid() ||
                !end.isAfter(start, 'day')
            ) {
                return {
                    valid: false,
                    actualNights: 0,
                    requiredNights: 1,
                    matchingRule: null
                };
            }

            const actualNights =
                end.diff(start, 'days');

            const requirement =
                getMinimumStayForStartDate(
                    dates.startDate,
                    accommodation
                );

            return {
                valid:
                    actualNights >= requirement.minNights,

                actualNights,

                requiredNights:
                    requirement.minNights,

                matchingRule:
                    requirement.matchingRule
            };
        },
        [
            accommodationSelected,
            getMinimumStayForStartDate
        ]
    );

    const showMinimumStayError = useCallback((validation) => {
        const ruleLabel = validation?.matchingRule?.label;
        const fallback = ruleLabel
            ? `${validation.requiredNights} nuits minimum sont requises pour la période « ${ruleLabel} ».`
            : `${validation.requiredNights} nuits minimum sont requises pour cette période.`;

        Helper.toast(
            t('errors.minimumStay', {
                count: validation.requiredNights,
                rule: ruleLabel || '',
                defaultValue: fallback
            }),
            'error'
        );
    }, [t]);

    const getPricesForDates = useCallback(async () => {
        const start = stayDates?.startDate;
        const end = stayDates?.endDate;
        const acc = accommodationSelected;

        // hard guards
        if (!start || !end || !acc) return;

        const days = moment(end).diff(start, 'days');
        if (!Number.isFinite(days) || days <= 0) return;

        // mark this request as the latest
        const token = Symbol('pricesForDates');
        lastPriceReqRef.current = token;

        try {
            const resp = await Api.getPricesForDates(start, end, acc);
            if (lastPriceReqRef.current !== token) return; // stale response, ignore

            if (_.get(resp, 'data.status')) {
                const data = _.get(resp, 'data.data', {});
                const total = Number(data.accommodationPrice || 0);
                const daily = days ? total / days : 0;

                setAccommodationPrice(daily);
                setDiscountLongAccommodation(Number(data.discountLongAccommodation || 0));

                setPrices(prev => ({
                    ...prev,
                    [acc]: {
                        ...prev[acc],
                        price: Number(daily.toFixed(2)),
                        base: Number((data.basePrice ?? prev[acc]?.base ?? 0).toFixed(2)),
                        cleaning: Number(data.cleaning || 0),
                        promotion: Number(data.promotionDiscount || 0), // ⬅️ NEW
                    },
                }));
            }
        } catch (e) {
            console.error('getPricesForDates failed', e);
        }
    }, [stayDates?.startDate, stayDates?.endDate, accommodationSelected]);

    const getPricesForAllAccommodations = useCallback(async () => {
        if (!stayDates?.startDate || !stayDates?.endDate) return;

        const days = getNbDaysStay();
        if (!days || days <= 0) return;

        const accs = displayedAccommodation; // ['domain','home','annex']

        const results = await Promise.all(
            accs.map(async (acc) => {
                try {
                    const resp = await Api.getPricesForDates(stayDates.startDate, stayDates.endDate, acc);

                    if (_.get(resp, 'data.status')) {
                        const data = _.get(resp, 'data.data', {});
                        const total = Number(data.accommodationPrice || 0);
                        const daily = days ? total / days : 0;
                        const base = data.basePrice;
                        const promo = Number(data.promotionDiscount || 0);

                        return { acc, daily: Number(daily.toFixed(2)), base: Number(base.toFixed(2)), cleaning: Number(_.get(data, 'cleaning', 0)), promotion: promo };
                    }
                } catch (e) {
                    console.error(`getPricesForDates failed for ${acc}`, e);
                }
                return { acc, daily: null, cleaning: null };
            })
        );

        setPrices(prev => {
            const next = { ...prev };
            results.forEach(({ acc, daily, base, cleaning, promotion }) => {
                if (daily !== null) {
                    next[acc] = { ...next[acc], price: daily, base, cleaning, promotion };
                }
            });
            return next;
        });
    }, [stayDates, displayedAccommodation, getNbDaysStay]);

    const fetchWithRetry = async (apiCall, setter, defaultValue = {}, maxRetries = 3) => {
        let attempts = 0;
        while (attempts < maxRetries) {
            try {
                const response = await apiCall();
                if (response.data.status) {
                    setter(response.data.data ?? defaultValue); // Ensure default value if response.data.data is undefined
                    return;
                } else {
                    console.log(`Error (attempt ${attempts + 1}):`, response.data.error);
                }
            } catch (error) {
                console.error(`An error occurred (attempt ${attempts + 1}):`, error);
            }
            attempts++;
            if (attempts < maxRetries) {
                await new Promise((resolve) => setTimeout(resolve, 1000));
            }
        }

        // If all attempts fail, set default value
        setter(defaultValue);
    };

    useEffect(() => {
        (async () => {
            try {
                await fetchWithRetry(
                    Api.getAllServices,
                    (data) => { setServices(data || []); },
                    []
                );

                await fetchWithRetry(
                    Api.getMinimumStayRules,
                    (data) => { setMinimumStayRules(data || []); },
                    []
                );

                const storedBlockedDates =
                    Api.getBlockedDatesStored() || [];

                const normalizedBlockedDates =
                    storedBlockedDates
                        .map(normalizeBlockedDate)
                        .filter(blockedDate => {
                            return (
                                moment(
                                    blockedDate.startDate,
                                    'YYYY-MM-DD',
                                    true
                                ).isValid() &&
                                moment(
                                    blockedDate.endDate,
                                    'YYYY-MM-DD',
                                    true
                                ).isValid()
                            );
                        });

                setBlockedDates(normalizedBlockedDates);
            } catch (e) {
                console.error(e);
            }
        })();
    }, []);

    const getBlockedDatesForAccommodation = useCallback(
        (accommodation) => {
            let blockingTypes;

            if (!accommodation) {
                /*
                 * No accommodation selected:
                 * show only complete-domain blocks.
                 */
                blockingTypes = ['domain'];
            } else {
                const selectedAccommodation =
                    normalizeBlockedAccommodation(
                        accommodation
                    );

                switch (selectedAccommodation) {
                    case 'home':
                        blockingTypes = [
                            'domain',
                            'home'
                        ];
                        break;

                    case 'annex':
                        blockingTypes = [
                            'domain',
                            'annex'
                        ];
                        break;

                    case 'domain':
                        blockingTypes = [
                            'domain',
                            'home',
                            'annex'
                        ];
                        break;

                    default:
                        blockingTypes = ['domain'];
                        break;
                }
            }

            return blockedDates.filter(blockedDate => {
                const blockedAccommodation =
                    normalizeBlockedAccommodation(
                        blockedDate.typeOfAccommodation
                    );

                return blockingTypes.includes(
                    blockedAccommodation
                );
            });
        },
        [blockedDates]
    );

    const calendarBlockedDates =
        getBlockedDatesForAccommodation(
            accommodationSelected
        );

    const blockedDateOverlapsStay = useCallback(
        (blockedDate, dates) => {
            if (
                !dates?.startDate ||
                !dates?.endDate
            ) {
                return false;
            }

            const stayStart = moment(
                dates.startDate
            ).startOf('day');

            /*
             * Checkout date is exclusive.
             */
            const stayEnd = moment(
                dates.endDate
            ).startOf('day');

            const blockedStart = moment(
                blockedDate.startDate ??
                blockedDate.start
            ).startOf('day');

            /*
             * The blocked end is also the checkout date,
             * so it remains exclusive.
             */
            const blockedEnd = moment(
                blockedDate.endDate ??
                blockedDate.end
            ).startOf('day');

            if (
                !stayStart.isValid() ||
                !stayEnd.isValid() ||
                !blockedStart.isValid() ||
                !blockedEnd.isValid()
            ) {
                return false;
            }

            return (
                stayStart.isBefore(
                    blockedEnd,
                    'day'
                ) &&
                stayEnd.isAfter(
                    blockedStart,
                    'day'
                )
            );
        },
        []
    );

    const isStayBlockedForAccommodation = useCallback(
        (dates, accommodation) => {
            const relevantBlockedDates =
                getBlockedDatesForAccommodation(
                    accommodation
                );

            return relevantBlockedDates.some(
                blockedDate =>
                    blockedDateOverlapsStay(
                        blockedDate,
                        dates
                    )
            );
        },
        [
            getBlockedDatesForAccommodation,
            blockedDateOverlapsStay
        ]
    );

    // ONLY WHEN NO DATES: rack/base prices (and when dates are cleared)
    useEffect(() => {
        if (stayDates?.startDate || stayDates?.endDate) return; // skip if any date is present

        (async () => {
            try {
                await fetchWithRetry(Api.getPrices, setPrices, {
                    annex: { price: 0, listOfDiscountForLongReservation: [], cleaning: 0 },
                    home: { price: 0, listOfDiscountForLongReservation: [], cleaning: 0 },
                    domain: { price: 0, listOfDiscountForLongReservation: [], cleaning: 0 }
                });
            } catch (e) {
                console.error(e);
            }
        })();
    }, [stayDates?.startDate, stayDates?.endDate]);

    useEffect(() => {
        if (stayDates) {
            getPricesForDates();
        }
    }, [stayDates, accommodationSelected, getPricesForDates]);

    useEffect(() => {
        if (stayDates?.startDate && stayDates?.endDate) {
            getPricesForAllAccommodations();
        }
    }, [stayDates, getPricesForAllAccommodations]);

    // Store data in localStorage whenever it changes
    useEffect(() => {
        localStorage.setItem('stayDates', JSON.stringify(stayDates));
    }, [stayDates]);

    useEffect(() => {
        localStorage.setItem('nbAdults', nbAdults);
    }, [nbAdults]);

    useEffect(() => {
        localStorage.setItem('nbChilds', nbChilds);
    }, [nbChilds]);

    useEffect(() => {
        localStorage.setItem('accommodationSelected', JSON.stringify(accommodationSelected));
    }, [accommodationSelected]);

    useEffect(() => {
        localStorage.setItem('servicesSelected', JSON.stringify(servicesSelected));
    }, [servicesSelected]);

    useEffect(() => {
        localStorage.setItem('personnalInfoFormData', JSON.stringify(personnalInfoFormData));
    }, [personnalInfoFormData]);

    const SERENITY_SLUG = "serenity-pack";
    const serenityPricePerDay = accommodationSelected
        ? (accommodationSelected === "domain" ? 400 : 200)
        : 0;

    const isSerenityAdded = servicesSelected.some(s => s.slug === SERENITY_SLUG);

    const upsertSerenityService = (price) => {
        const base = {
            slug: SERENITY_SLUG,
            name: { fr: "Pack Sérénité", en: "Serenity Pack" }, // i18n labels
            quantity: 1,
            isPriceDefined: true,
            price: Number(price),
            VAT: 0,
            priceMustBePaidEach: "day",                 // billed per day
            isPricePerPersonOrForEveryone: "forEveryone"// for the whole group
        };

        setServicesSelected(prev => {
            const others = prev.filter(s => s.slug !== SERENITY_SLUG);
            return [...others, base];
        });
    };

    const removeSerenityService = () => {
        setServicesSelected(prev => prev.filter(s => s.slug !== SERENITY_SLUG));
    };

    const toggleSerenity = () => {
        if (isSerenityAdded) removeSerenityService();
        else upsertSerenityService(serenityPricePerDay);
    };

    useEffect(() => {
        if (!isSerenityAdded) return;
        setServicesSelected(prev =>
            prev.map(s =>
                s.slug === SERENITY_SLUG ? { ...s, price: serenityPricePerDay } : s
            )
        );
    }, [accommodationSelected, serenityPricePerDay, isSerenityAdded]);

    const numberOptions = (labelKey, maxNumber = 22) => {
        return Array.from({ length: maxNumber + 1 }, (_, index) => {
            if (labelKey === "adult" && index === 0) {
                return null; // Exclude the option with value 0
            }
            return {
                value: `${index}`,
                label: `${index} ${t(`formInputs.${labelKey}`)}${index > 1 ? 's' : ''}`,
            };
        }).filter(option => option !== null);
    };

    const handleDateChange = (e) => {
        const newDates = e.date;

        if (newDates?.startDate && newDates?.endDate) {
            const validation = getMinimumStayValidation(newDates);

            if (!validation.valid) {
                setStayDates({ startDate: null, endDate: null });
                showMinimumStayError(validation);
                return;
            }
        }

        setStayDates(newDates);
    };

    const getPriceAccommodation = () => {
        if (!accommodationSelected) return 0;

        let price = prices[accommodationSelected].price;
        return displayNumberWithSpace(price);
    }

    const getSubTotalAccommodation = () => {
        if (!stayDates.startDate || !stayDates.endDate) return 0;

        const days = getNbDaysStay();
        const accommodationPriceWithoutSpaces = String(getPriceAccommodation()).replace(/\s/g, '');
        const accommodationPriceFloat = parseFloat(accommodationPriceWithoutSpaces);

        const amountStayCleaningFees = getPriceEndOfStayCleaningFees();
        const touristTax = getPriceTouristTax();

        const total = (days * accommodationPrice || accommodationPriceFloat) - discountLongAccommodation + amountStayCleaningFees + touristTax;

        if (lodash.isNaN(total)) {
            return NaN;
        }

        return displayNumberWithSpace(total);
    }

    const displayNumberWithSpace = (value) => {
        const num = Number(value);
        if (!Number.isFinite(num)) return "0.00";

        // Fix floating precision
        const rounded = Math.round((num + Number.EPSILON) * 100) / 100;

        // 2 decimals, always
        const [intPart, decimalPart] = rounded.toFixed(2).split(".");

        // Add spaces only in the integer part
        const intWithSpaces = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, " ");

        // Use "." or "," as you prefer
        return `${intWithSpaces}.${decimalPart}`; // or `${intWithSpaces},${decimalPart}` for FR
    }

    const getPriceEndOfStayCleaningFees = () => {
        if (!accommodationSelected) return 0;

        const price = prices[accommodationSelected]?.cleaning;
        return price;
    }

    const getPriceTouristTax = () => {
        const nbDays = getNbDaysStay();

        const startDate = new Date(stayDates.startDate);
        const thresholdDate = new Date('2026-01-01');
        touristTax = startDate >= thresholdDate ? 3.63 : 3.30;

        return Number((nbAdults * touristTax * nbDays).toFixed(2));
    };

    const getTotal = () => {
        // const accommodation = getSubTotalAccommodation().replace(/\s/g, '');
        let accommodation = getSubTotalAccommodation();
        if (!lodash.isNaN(accommodation) && accommodation !== 0) accommodation = accommodation.replace(/\s/g, '');

        const services = getSubTotalServices().replace(/\s/g, '');

        let total = Number(accommodation) + Number(services);

        if (lodash.isNaN(total)) {
            return NaN;
        }

        return displayNumberWithSpace(total);
    }

    const handleSelectChangeAdults = (event) => {
        const selectedAdults = Number(event.target.value);
        const totalPersons = selectedAdults + nbChilds;

        if (totalPersons > 22) {
            setNbChilds(22 - selectedAdults);
        }

        setNbAdults(selectedAdults);
    };

    const handleSelectChangeChilds = (event) => {
        const selectedChildren = Number(event.target.value);
        const totalPersons = nbAdults + selectedChildren;

        if (totalPersons > 22) {
            setNbAdults(22 - selectedChildren);
        }

        setNbChilds(selectedChildren);
    };

    const onSelectAccommodation = (value) => {
        const totalPeople =
            Number(nbAdults || 0) +
            Number(nbChilds || 0);

        if (
            value === 'home' &&
            totalPeople > maxPeopleHome
        ) {
            return Helper.toast(
                t('errors.tooManyPeopleHome'),
                'error'
            );
        }

        if (
            value === 'annex' &&
            totalPeople > maxPeopleAnnex
        ) {
            return Helper.toast(
                t('errors.tooManyPeopleAnnex'),
                'error'
            );
        }

        /*
         * Dates are selected before the accommodation,
         * so verify availability now.
         */
        if (
            stayDates?.startDate &&
            stayDates?.endDate &&
            isStayBlockedForAccommodation(
                stayDates,
                value
            )
        ) {
            return Helper.toast(
                t('errors.accommodationUnavailable', {
                    defaultValue:
                        'Cet hébergement n’est pas disponible aux dates sélectionnées.'
                }),
                'error'
            );
        }

        setAccommodationSelected(value);
    };

    const getNbMaxPeople = () => {
        if (!accommodationSelected || accommodationSelected === "domain") {
            return maxPeopleDomain;

        } else if (accommodationSelected === "home") {
            return maxPeopleHome;

        } else if (accommodationSelected === "annex") {
            return maxPeopleAnnex;
        }

    }

    const onSelectService = (value) => {
        setServicesSelected(value);
    }

    const getPriceService = (service) => {
        let total = 0;
        if (!service.isPriceDefined) return;

        if (service.isPricePerPersonOrForEveryone === "perPerson") {
            if (service.priceMustBePaidEach === "day") {
                total += service.price * (Number(nbAdults) + Number(nbChilds)) * getNbDaysStay();
            } else {
                total += service.price * (Number(nbAdults) + Number(nbChilds));
            }
        } else {
            if (service.priceMustBePaidEach === "day") {
                total += service.price * service.quantity * getNbDaysStay();
            } else {
                total += service.price * service.quantity;
            }
        }

        return displayNumberWithSpace(total);
    };

    const getSubTotalServices = () => {
        let totalPrice = 0;

        for (const service of servicesSelected) {
            const total = getPriceService(service);
            if (total) {
                // total is a formatted string → we’d better recompute or change getPriceService
                // Simpler: compute numeric again here
                let numeric = 0;

                if (service.isPriceDefined) {
                    if (service.isPricePerPersonOrForEveryone === "perPerson") {
                        if (service.priceMustBePaidEach === "day") {
                            numeric += service.price * (Number(nbAdults) + Number(nbChilds)) * getNbDaysStay();
                        } else {
                            numeric += service.price * (Number(nbAdults) + Number(nbChilds));
                        }
                    } else {
                        if (service.priceMustBePaidEach === "day") {
                            numeric += service.price * service.quantity * getNbDaysStay();
                        } else {
                            numeric += service.price * service.quantity;
                        }
                    }
                }

                totalPrice += numeric;
            }
        }
        return displayNumberWithSpace(totalPrice);
    }

    const clickDisplayFormContactDetails = () => {
        if (!stayDates.startDate || !stayDates.endDate) {
            return Helper.toast(t('errors.noDate'), "error");

        } else if (!nbAdults) {
            return Helper.toast(t('errors.noNbPersons'), "error");

        } else if (!accommodationSelected) {
            return Helper.toast(t('errors.noAccommodationSelected'), "error");

        } else {
            const tomorrow = new Date();
            tomorrow.setHours(0, 0, 0, 0);
            tomorrow.setDate(tomorrow.getDate() + 1);

            const maxAllowedDate = new Date(twoYearsLater);
            maxAllowedDate.setHours(0, 0, 0, 0);

            const startDate = new Date(stayDates.startDate);
            const endDate = new Date(stayDates.endDate);
            startDate.setHours(0, 0, 0, 0);
            endDate.setHours(0, 0, 0, 0);

            if (startDate < tomorrow || endDate < tomorrow) {
                return Helper.toast(t('errors.invalidDate'), "error");
            }

            if (startDate > maxAllowedDate || endDate > maxAllowedDate) {
                return Helper.toast(t('errors.invalidMaxDate'), "error");
            }

            const minimumStayValidation = getMinimumStayValidation(stayDates);
            if (!minimumStayValidation.valid) {
                showMinimumStayError(minimumStayValidation);
                return;
            }
        }

        if (
            isStayBlockedForAccommodation(
                stayDates,
                accommodationSelected
            )
        ) {
            return Helper.toast(
                t('errors.blockedDates', {
                    defaultValue:
                        'Cet hébergement n’est pas disponible aux dates sélectionnées.'
                }),
                'error'
            );
        }

        setDisplayFormContactDetails(true);
    };

    async function sendQuotation() {
        if (isSendingQuotation) return;

        if (!stayDates.startDate || !stayDates.endDate) {
            return Helper.toast(t('errors.noDate'), "error");

        } else if (!nbAdults) {
            return Helper.toast(t('errors.noNbPersons'), "error");

        } else if (!accommodationSelected) {
            return Helper.toast(t('errors.noAccommodationSelected'), "error");

        } else {
            const tomorrow = new Date();
            tomorrow.setHours(0, 0, 0, 0);
            tomorrow.setDate(tomorrow.getDate() + 1);

            if (new Date(stayDates.startDate) < tomorrow || new Date(stayDates.endDate) < tomorrow) {
                return Helper.toast(t('errors.invalidDate'), "error");
            }

            if (
                isStayBlockedForAccommodation(
                    stayDates,
                    accommodationSelected
                )
            ) {
                return Helper.toast(
                    t('errors.blockedDates', {
                        defaultValue:
                            'Cet hébergement n’est plus disponible aux dates sélectionnées.'
                    }),
                    'error'
                );
            }

            const minimumStayValidation = getMinimumStayValidation(stayDates);
            if (!minimumStayValidation.valid) {
                showMinimumStayError(minimumStayValidation);
                return;
            }
        }

        const tmpErrorsPersonnalInfo = Validator.validatePersonnalInfoQuotationFormData(personnalInfoFormData, t);
        setErrorsPersonnalInfo(tmpErrorsPersonnalInfo);

        if (Object.keys(tmpErrorsPersonnalInfo).length === 0) {
            try {
                setIsSendingQuotation(true);

                const quotation = {
                    dates: {
                        startDate: stayDates.startDate,
                        endDate: stayDates.endDate,
                        creationDate: new Date(),
                        expirationDate: new Date(new Date().setMonth(new Date().getMonth() + 1))
                    },
                    mainInfos: {
                        status: 'sent',
                        language: i18n.language,
                        numberOfGuests: {
                            adults: nbAdults,
                            childs: nbChilds
                        }
                    },
                    prices: {
                        accommodationPrice: Number(Number(accommodationPrice * getNbDaysStay()).toFixed(2)),
                        typeOfAccommodation: accommodationSelected,
                        totalPrice: Number(String(getTotal().replace(/\s/g, ''))),
                        cleaning: Number(getPriceEndOfStayCleaningFees()),
                        discountLongAccommodation: discountLongAccommodation,
                        touristTax: getPriceTouristTax()
                    },
                    customer: {
                        lastname: personnalInfoFormData.lastname,
                        firstname: personnalInfoFormData.firstname,
                        email: personnalInfoFormData.email,
                        phone: personnalInfoFormData.phone
                    },
                    guests: [],
                    address: {},
                    services: servicesSelected.map(service => ({
                        slug: service.slug,
                        name: service.name['fr'],
                        quantity: service.quantity,
                        isPriceDefined: service.isPriceDefined,
                        price: service.isPriceDefined ? Number(service.price) : 0,
                        VAT: service.VAT,
                        priceMustBePaidEach: service.priceMustBePaidEach
                    })),
                    history: []
                };

                Helper.toast(t('reservation.sending'), "info");
                const response = await Api.saveQuotation(quotation);
                // Helper.handleApiResponse(response, t('responses.quotationSend'), t('responses.quotationError'));
                const responseEmail = await Api.sendQuotation(response.data.data);
                Helper.handleApiResponse(responseEmail, t('responses.quotationSent'), t('responses.quotationError'));
                setDisplayFormContactDetails(false);

                if (_.get(response, 'data.status')) {
                    window.dataLayer = window.dataLayer || [];
                    window.dataLayer.push({
                        event: 'quotationFormSubmissionSuccess',
                        formType: 'quotation'
                    });
                }

                if (response.data?.status && response.data?.data?._id) {
                    const quotationId = response.data.data._id;
                    navigate(`/quotation/${quotationId}`);
                    window.scrollTo({
                        top: 0,
                        behavior: "smooth",
                    });
                    return Helper.toast(t('responses.quotationSend'), "success");
                } else {
                    console.error("Quotation ID not found in the response.");
                }
            } finally {
                setIsSendingQuotation(false);
            }
        }
    }

    const twoYearsLater = new Date(new Date().setFullYear(new Date().getFullYear() + 2));

    const toIsoDay = (d) => new Date(d).toISOString().slice(0, 10);

    const loadCheaperDates = useCallback(async () => {
        const from = toIsoDay(new Date());
        const to = toIsoDay(new Date(new Date().setFullYear(new Date().getFullYear() + 2)));

        const acc = accommodationSelected || 'domain';

        // baseline
        let base = Number(_.get(prices, [acc, 'base']) ?? _.get(prices, [acc, 'price']) ?? 0);
        if (!Number.isFinite(base) || base <= 0) {
            try {
                const baseResp = await Api.getPrices();
                const rack = Number(_.get(baseResp, ['data', 'data', acc, 'price']));
                if (Number.isFinite(rack) && rack > 0) base = rack;
            } catch (e) { /* ignore */ }
        }

        const resp = await Api.getDayOverrides(from, to, acc);
        const list = _.get(resp, 'data.data', []);

        const fmt = (d) =>
            typeof d === 'string' ? d.slice(0, 10) : toIsoDay(d);

        // ⚠️ corrige la condition « cheaper-than-base »
        const cheaperNonPromoDates = Number.isFinite(base) && base > 0
            ? list
                .filter(it => !it.isPromotion && Number(it.price) < base)
                .map(it => fmt(it.date))
            : [];

        const promoDates = list
            .filter(it => !!it.isPromotion)
            .map(it => fmt(it.date));

        setCheaperDates(cheaperNonPromoDates);   // déjà existant
        setPromoDates(promoDates);               // ➜ nouveau state
    }, [accommodationSelected, prices]);

    useEffect(() => {
        if (ranInitialCheapRef.current) return;
        ranInitialCheapRef.current = true;
        loadCheaperDates();
    }, [loadCheaperDates]);

    useEffect(() => {
        const baseReady = accommodationSelected && _.get(prices, [accommodationSelected, 'price'], null) !== null;
        if (baseReady) {
            loadCheaperDates();
        }
    }, [accommodationSelected, prices, loadCheaperDates]);

    const datesReady = !!(stayDates?.startDate && stayDates?.endDate);

    useEffect(() => {
        if (datesReady && accommodationSelected) {
            getPricesForDates();
        }
    }, [datesReady, accommodationSelected, getPricesForDates]);

    const getPromotionAmount = () => {
        if (!accommodationSelected) return 0;
        const val = Number(prices[accommodationSelected]?.promotion || 0);
        return Number.isFinite(val) ? val : 0; // typically negative (e.g., -991)
    };

    return (
        <div>
            <Helmet>
                <title>{t('reservation.page')}</title>
                <meta name="description" content={t('reservation.description')} />
                <meta name="keywords" content={t('reservation.keywords')} />
            </Helmet>

            <div className="absolute top-0 w-full">
                <BackgroundImage image={imageHeaderBanner} alt={t('reservation.altBackground')} customHeight={"50vh"} />
            </div>

            <div className="max-w-[2000px] m-auto relative w-11/12 sm:w-11/12 md:w-5/6 lg:w-5/6 2xl:w-3/4 mx-auto mt-20 md:mt-36 flex flex-col md:flex-row gap-6 md:gap-10 mb-10">
                <div className="w-full md:w-3/5 bg-white py-6 px-4 md:px-8 h-fit shadow-lg">
                    <H2 title={t('reservation.quotation.title')} fontWeight='normal' />
                    <div className="text-xs font-normal mt-2">
                        <DescriptionSplit description={t('reservation.quotation.description')} />
                        {/* <DescriptionSplit description={t('reservation.quotation.additionnalDescription')} className="font-bold" /> */}
                    </div>

                    <H3 title={t('reservation.period.title')} fontWeight='normal' className="mt-6 mb-2" />
                    <div className="flex w-full">
                        <DateFieldInput label='stayDate' value={stayDates} minDate={new Date()} maxDate={twoYearsLater} onChange={handleDateChange} displayLabel={false} singleDate={false} blockedDates={calendarBlockedDates} highlightDates={cheaperDates} promoDates={promoDates} getMinimumStayForStartDate={getMinimumStayForStartDate} className="rounded-none" />
                    </div>
                    <div className="w-full block md:flex">
                        <Select label="adults" name={t('formInputs.adult')} options={numberOptions("adult", getNbMaxPeople() - nbChilds)} value={nbAdults}
                            onChange={handleSelectChangeAdults} displayLabel={false} iconDisplayed={faUser} error={null} placeholder={'reservation.details.nbAdults'} className="rounded-none" />
                        <Select label="childs" name={t('formInputs.child')} options={numberOptions("child", getNbMaxPeople() - nbAdults)} value={nbChilds}
                            onChange={handleSelectChangeChilds} displayLabel={false} iconDisplayed={faUser} error={null} placeholder={'reservation.details.nbChildsWithAge'} className="rounded-none" />
                    </div>

                    <H3 title={t('reservation.accommodation.title')} fontWeight='normal' className="mt-8 mb-2" />
                    <DescriptionSplit description={t('reservation.accommodation.description')} />
                    <div className="my-4 flex flex-col justify-between gap-4">
                        <AccommodationDisplayed accommodation={displayedAccommodation} accommodationSelected={accommodationSelected} prices={prices} totalPeople={nbAdults + nbChilds} onChange={onSelectAccommodation} />
                    </div>

                    <SerenityPackCard
                        pricePerDay={serenityPricePerDay}
                        onToggle={toggleSerenity}
                        isAdded={isSerenityAdded}
                        disabled={!accommodationSelected}
                    />

                    <H3 title={t('reservation.quotation.services.title')} fontWeight='normal' />
                    <div className="text-xs font-normal mt-2 mb-6">
                        <DescriptionSplit description={t('reservation.quotation.services.description')} />
                    </div>

                    <ListOfServices services={services} servicesSelectedsaved={servicesSelected} numberOfGuests={nbAdults + nbChilds} onChange={onSelectService} />
                </div>

                <div id="fixed-column" className="w-full md:w-2/5 h-auto flex flex-col">
                    <div className={`h-full flex flex-col ${divHeight + 160 > screenHeight ? "justify-end" : "justify-start"}`}>
                        <div ref={fixedColumnRef} className={`bg-white py-6 px-4 md:px-8 shadow-lg ${divHeight + 160 > screenHeight ? "bottom-6" : "top-[160px]"} sticky`}>
                            <div className="text-center">
                                <H3 title={t('reservation.details.title')} fontWeight="normal" />
                            </div>

                            <Hr />

                            <div>
                                <div className="flex gap-2 mb-2">
                                    <Icon icon={iconCalendar} />
                                    <H5 title={t('reservation.details.dates')} underline={true} />
                                </div>
                                {stayDates.startDate && stayDates.endDate ? (
                                    <span className="opacity-60">
                                        {new Date(stayDates.startDate).toLocaleDateString('fr-FR')} -
                                        {new Date(stayDates.endDate).toLocaleDateString('fr-FR')}
                                    </span>
                                ) : (
                                    <span className="opacity-60">
                                        {t('reservation.details.noDate')}
                                    </span>
                                )}
                            </div>

                            <div className="my-4">
                                <div className="flex gap-2 mb-2">
                                    <Icon icon={iconUsers} />
                                    <H5 title={t('reservation.details.nbAdults')} underline={true} />
                                </div>
                                <span className="opacity-60">
                                    {nbAdults || 0} {t('reservation.details.adults')}{nbAdults > 1 ? 's' : ''}
                                </span>
                            </div>

                            <div>
                                <div className="flex gap-2 mb-2">
                                    <Icon icon={iconUsers} />
                                    <H5 title={t('reservation.details.nbChilds')} underline={true} />
                                    <span className="opacity-50">{t('reservation.details.nbChildsAge')}</span>
                                </div>
                                <span className="opacity-60">
                                    {nbChilds || 0} {t('reservation.details.childs')}{nbChilds > 1 ? 's' : ''}
                                </span>
                            </div>

                            <Hr />

                            <div className="flex gap-2">
                                <Icon icon={iconAccommodation} />
                                <H5 title={t('reservation.details.accommodation')} underline="true" />
                            </div>
                            {accommodationSelected && (
                                <H5
                                    title={t(`reservation.accommodation.${accommodationSelected}.title`)}
                                    fontWeight="bold"
                                    className="mt-2 mb-4"
                                />
                            )}
                            <div className="mt-1 flex justify-between opacity-60">
                                <H6
                                    title={
                                        t('reservation.details.pricePerNight') +
                                        ` (${getNbDaysStay()} ${t('reservation.night')}${getNbDaysStay() > 1 ? 's' : ''
                                        })`
                                    }
                                />
                                <H6 title={displayNumberWithSpace(accommodationPrice.toFixed(2)) + '€'} />
                            </div>

                            {discountLongAccommodation !== 0 && (
                                <div className="pl-6 mt-1 flex justify-between opacity-60">
                                    <span className="text-sm">
                                        {t('reservation.details.discountLongAccommodation')}
                                    </span>
                                    <span className="text-sm">-{discountLongAccommodation}€</span>
                                </div>
                            )}

                            {getPromotionAmount() !== 0 && (
                                <div className="pl-6 mt-1 flex justify-between opacity-60">
                                    <span className="text-sm">{t('reservation.details.promotion')}</span>
                                    <span className="text-sm">{
                                        lodash.isNaN(getPromotionAmount())
                                            ? t('errors.error')
                                            : `${getPromotionAmount()}€`
                                    }</span>
                                </div>
                            )}

                            <div className="pl-6 mt-1 flex justify-between opacity-60">
                                <span className="text-sm">{t('reservation.details.laundry')}</span>
                                <span className="text-sm">{t('reservation.details.include')}</span>
                            </div>

                            <div className="pl-6 mt-1 flex justify-between opacity-60">
                                <span className="text-sm">{t('reservation.details.dailyCleaningFees')}</span>
                                <span className="text-sm">{t('reservation.details.include')}</span>
                            </div>

                            <div className="mt-1 flex justify-between opacity-60">
                                <H6 title={t('reservation.details.endOfStayCleaningFees')} />
                                <H6
                                    title={
                                        lodash.isNaN(getPriceEndOfStayCleaningFees())
                                            ? t('errors.error')
                                            : displayNumberWithSpace(getPriceEndOfStayCleaningFees()) + '€'
                                    }
                                />
                            </div>

                            <div className="mt-1 flex justify-between opacity-60">
                                <H6 title={t('reservation.details.touristTax')} />
                                <H6 title={displayNumberWithSpace(getPriceTouristTax()) + '€'} />
                            </div>

                            <div className="flex mt-4 justify-between">
                                <H4 title={t('reservation.details.subtotal')} />
                                <span>
                                    {lodash.isNaN(getSubTotalAccommodation())
                                        ? t('errors.error')
                                        : displayNumberWithSpace(getSubTotalAccommodation()) + '€'}
                                </span>
                            </div>

                            <Hr />

                            <div className="flex gap-2">
                                <Icon icon={iconServices} />
                                <H5 title={t('reservation.details.services')} underline="true" />
                            </div>

                            <div className="pl-6 flex justify-between opacity-60">
                                <span className="text-sm">{t('reservation.details.concierge')}</span>
                                <span className="text-sm">{t('reservation.details.include')}</span>
                            </div>

                            {servicesSelected.length > 0 && (
                                <>
                                    {servicesSelected.map((service, index) => (
                                        <div className="pl-6 flex justify-between opacity-60" key={index}>
                                            <span className="text-sm">
                                                {service.slug === SERENITY_SLUG ? (
                                                    <>
                                                        {service.name[i18n.language] || service.name.en}
                                                    </>
                                                ) : (
                                                    <>
                                                        {service.quantity}x&nbsp;
                                                        {service.name[i18n.language] || service.name.en}
                                                    </>
                                                )}
                                            </span>

                                            {service.isPriceDefined ? (
                                                <span className="text-sm">
                                                    {getPriceService(service) === '0'
                                                        ? t('reservation.services.free')
                                                        : displayNumberWithSpace(getPriceService(service)) + '€'}
                                                </span>
                                            ) : (
                                                <span className="text-sm">{t('reservation.details.toDefine')}</span>
                                            )}
                                        </div>
                                    ))}
                                </>
                            )}

                            <div className="flex mt-4 justify-between">
                                <H4 title={t('reservation.details.subtotal')} />
                                <span>{getSubTotalServices()}€</span>
                            </div>

                            <Hr />

                            <div className="flex mt-4 justify-between">
                                <H3 title={t('reservation.details.total')} />
                                <span className="font-bold">
                                    {(() => {
                                        const num = Number(String(getTotal()).replace(/\s/g, '').replace(',', '.'));
                                        return lodash.isNaN(num)
                                            ? t('errors.error')
                                            : `${String(num.toFixed(2)).replace(/\B(?=(\d{3})+(?!\d))/g, ' ')}€`;
                                    })()}
                                </span>
                            </div>

                            {!displayFormContactDetails ? (
                                <>
                                    <div className="mt-10 text-center w-full">
                                        <Button
                                            onClick={clickDisplayFormContactDetails}
                                            text={t('reservation.details.getQuotation')}
                                            className="w-full"
                                            disabled={lodash.isNaN(getTotal())}
                                            error={t('errors.priceError')}
                                        />
                                    </div>
                                    {/* <span className="mt-4 block text-center w-full">
                                        {t('reservation.details.contactFinalizeQuotation')}
                                    </span> */}
                                </>
                            ) : (
                                <>
                                    <Hr />
                                    <H5
                                        title={t(t('reservation.details.descriptionContactForm'))}
                                        className="text-center mb-8"
                                    />
                                    <PersonnalInfoForm
                                        customer={personnalInfoFormData}
                                        errors={errorsPersonnalInfo}
                                        updatePersonnalInfoFormData={updatePersonnalInfoFormData}
                                        fullWidth={true}
                                    />
                                    <Button onClick={sendQuotation} text={t('reservation.details.validate')} disabled={isSendingQuotation} className="mt-8 w-full" />
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}